import { carouselItems } from '@/mocks/siteData';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">重磅专题深度报道，一次性吃透每颗大瓜</p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col md:flex-row bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="md:w-[380px] lg:w-[440px] flex-shrink-0 relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-52 md:h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute top-4 left-4">
                  <span className={`text-xs px-3 py-1 rounded-full font-medium ${tagColorMap[item.tagColor] || tagColorMap.primary}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
                <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}